import React from "react";
import { Col, Row, Tooltip } from "react-bootstrap";
import { PieChart } from "devextreme-react";
import CharBarForPosition from "./components/CharBarForPosition";
import {
  Connector,
  Font,
  Legend,
  Series,
  Label,
} from "devextreme-react/cjs/chart";

import { SmallValuesGrouping } from "devextreme-react/cjs/pie-chart";

const ResourcesGraphCluster = ({ users, clusters, projects }) => {

    const projCritico = projects?.filter(item => item.PctCompletadoProyecto < 100).filter((item) => {
    let desv = Math.round(item.PctCompletadoProyecto - (item.PctPlaneadoProyecto? item.PctPlaneadoProyecto : item.PctPlaneadoProyecto))

    return (desv < -25)
  })
  const projModerado = projects?.filter(item => item.PctCompletadoProyecto < 100).filter((item) => {
    let desv = Math.round(item.PctCompletadoProyecto - (item.PctPlaneadoProyecto? item.PctPlaneadoProyecto : item.PctPlaneadoProyecto))

    return (desv <= -1 && desv >= -25)
  })
  const projAlDia = projects?.filter(item => item.PctCompletadoProyecto < 100).filter((item) => {
    let desv = Math.round(item.PctCompletadoProyecto - (item.PctPlaneadoProyecto? item.PctPlaneadoProyecto : item.PctPlaneadoProyecto))

    return (desv >= 0)
  })

  const dataChartPie = [
    {
      arg: "Crítico",
      val: projCritico.length
    },
    {
      arg: "Moderado",
      val: projModerado.length
    },
    {
      arg: "Al día",
      val: projAlDia.length
    },
  ];

  const customize = (pointInfo) => {

    return pointInfo.argument === "Crítico" || pointInfo.argument === "Critical"
      ? { color: "#EF000B" }
      : pointInfo.argument === "Moderado" || pointInfo.argument === "Moderate"
      ? { color: "#FDA80A" }
      : pointInfo.argument === "Al día" || pointInfo.argument === "On time"
      ? { color: "#59A915" }
      : { color: "#fdce56" };
  };

  function formatLabel(e) {
    return `${e.argumentText}\n (${e.valueText})`;
  }

  function customizeTooltip(arg) {
    return {
      text: `${arg.valueText} - ${(arg.percent * 100).toFixed(2)}%`,
    };
  }

  return (
    <div>
      <Row>
        <Col style={{ maxHeight: "350px" }} md={4}>
          <PieChart
            id="pie"
            type="doughnut"
            dataSource={dataChartPie}
            height="300px"
            title={"Estado de proyectos"}
            customizePoint={customize}
          >


            <Series argumentField="arg" valueField="val">
              <Label
                visible={true}
                customizeText={formatLabel}
                format="fixedPoint"
                position="columns"
              >
                <Font size={11} />
                <Connector visible={true} width={1} />
              </Label>
              <SmallValuesGrouping threshold={1} mode="smallValueThreshold" />
            </Series>

            <Legend
              margin={0}
              horizontalAlignment="right"
              verticalAlignment="top"
              visible={false}
            />
            <Tooltip
              enabled={true}
              customizeTooltip={customizeTooltip}
            ></Tooltip>
          </PieChart>
        </Col>
        <Col md={8}>
          <CharBarForPosition
            type="position"
            data={users}
            title="Cantidad de Recursos por Cargo"
          />
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(ResourcesGraphCluster);
